const content: { [key: string]: any } = {
  loginText: 'Please login to continue.',
  login: 'Login',
};

export default content;
